@if (status === IdCardDisplayStatus.MISSING_DATE) {
  <div class="flex items-center gap-[4px] text-error-400">
    <span class="material-icons text-[18px]">priority_high</span>
    <span>{{ "customer.idCard_missing_expiration_date" | translate }}</span>
  </div>
} @else if (status === IdCardDisplayStatus.EXPIRED) {
  <div class="flex items-center gap-[4px] text-error-400">
    <span class="material-icons text-[18px]">event_busy</span>
    <span>{{ "customer.idCard_expired" | translate }}</span>
  </div>
} @else if (status === IdCardDisplayStatus.RENEWAL) {
  <div class="flex items-center gap-[4px] text-warning-400">
    <span class="material-icons text-[18px]">event_busy</span>
    <span>{{ "customer.idCard_expiring_soon" | translate }}</span>
  </div>
} @else if (status === IdCardDisplayStatus.MISSING_CARD) {
  <div class="flex items-center gap-[4px] text-error-400">
    <span class="material-icons text-[18px]">priority_high</span>
    <span>{{ "customer.idCard_missing" | translate }}</span>
  </div>
}
